import {inject, Injectable} from '@angular/core';
import {ProductCardApiService} from "../services-api/product-card-api.service";
import {DetachProductCard, ProductCardData} from "../types/product-card-data.types";
import {ProductCard} from "../../../../core/components/modals/product-card-modal/types/product-card.types";
import {GetSelectDataParams, RecordUpdateRequestParams, SelectData} from "../../../../core/types/records-table.types";
import {RecordTableApiService} from "../../../../core/services-api/record-table-api.service";

@Injectable({
  providedIn: 'root'
})
export class ProductCardService {
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public detachProductCard(detachProductCard: DetachProductCard): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.detachProductCard(detachProductCard).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public updateProductCard(recordUpdateRequestParams: RecordUpdateRequestParams): Promise<ProductCard> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.updateProductCard(recordUpdateRequestParams).subscribe({
        next: (productCards: ProductCard) => resolve(productCards),
        error: (error) => reject(error)
      });
    });
  }

  public deleteProductCard(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.deleteProductCard(id).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public fetchProductCardSyncData(productCardId: number): Promise<ProductCardData> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchProductCardSyncData(productCardId).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public fetchSelectData(getSelectDataParams: GetSelectDataParams): Promise<Array<SelectData>> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
